import { Link } from '@tanstack/react-router'

import { Plus } from 'lucide-react'

import { SectionDescription, SectionTitle } from '@/features/app-shell/section'

import { HasActiveSystemManager } from '@/shared/auth/components/has-active-system-manager'

import { Button } from '@/components/ui/button'

/**
 * The overview's title and its single add affordance.
 *
 * Lives outside the page's Suspense/Error boundary and renders identically in
 * every state (P-05): a user whose health rollup failed to load must still be
 * able to add an integration.
 *
 * One button, not the Collectors page's two. This page is the catalog's front
 * door for **both** kinds — the catalog itself is shared (D12) and its tabs are
 * where Cloud and Network Log diverge — so a second "Add remote collector"
 * button here would put a host-installation flow beside a connector picker at
 * the exact point the user has not yet said which kind they want.
 *
 * Manager-gated because `/integrations/new` is already
 * `roleAuthGuard(SystemManager)`: ungated this would be a button that bounces a
 * read-only user off a guard (D34).
 */
export const IntegrationsOverviewHeader = () => {
	return (
		<div className="flex w-full flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
			<div className="flex flex-col gap-1">
				<SectionTitle>Integrations</SectionTitle>
				<SectionDescription>
					Everything feeding AIR® — health at a glance.
				</SectionDescription>
			</div>

			<HasActiveSystemManager>
				<Button
					className="shrink-0"
					nativeButton={false}
					render={
						<Link to="/integrations/new" preload="intent">
							<Plus className="size-4" /> Add integration
						</Link>
					}
				/>
			</HasActiveSystemManager>
		</div>
	)
}
